package com.nonopn.skydome.common.app.navigation

import androidx.compose.runtime.Composable
import com.nonopn.skydome.common.app.pages.probes.ProbeCreationScreen
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteProbeCreate : RouteParameterTo

// "Create my probes" screen (trial mode is passed through AppModel.pendingProbeTrial)
object RouterProbeCreate : RouterNoParameters<RouteProbeCreate>(RouteProbeCreate::class) {
    override fun routeFrom(parameters: RouteProbeCreate) = "/probes/create"

    @Composable
    override fun Show(parameters: RouteProbeCreate) {
        RouteProbeCreateImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteProbeCreate,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteProbeCreate

    override fun isMatching(route: String) = route == "/probes/create"

    override fun navigateFrom(path: String) = RouteProbeCreate
}

class RouteProbeCreateImpl : Route<RouteProbeCreate>(
    route = "/probes/create",
    params = RouteProbeCreate,
) {
    @Composable
    override fun scene() {
        // The app bar title (trial or not) is set by the screen itself
        ProbeCreationScreen()
    }
}
